import {FKOFAQSection} from '@/components/FKO/FKOFAQSection/FKOFAQSection';
import {ClassicPageContainer} from '@/components/PageContainer/ClassicPageContainer';
import {Outlet} from 'react-router-dom';

export default function FKOLayout() {
  return (
    <>
      <ClassicPageContainer>
        <Outlet />
      </ClassicPageContainer>
      <FKOFAQSection />
    </>
  );
}
